import React from "react";
import {
  Divider,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Avatar,
  Theme,
  createStyles,
  WithStyles,
  withStyles,
  Paper,
} from "@material-ui/core";
import {
  EQUIPMENT_STATUS_DATE_FORMAT,
  getMomentDate,
} from "../constants/constants";

const StyledTableCell = withStyles({
  root: {
    width: 150,
    padding: "0px 0px",
  },
})(TableCell);

const styles = (theme: Theme) =>
  createStyles({
    chip: {
      margin: theme.spacing(0.5),
    },
    table: {
      minWidth: 700,
    },
    root: {
      width: 150,
      padding: "0px 0px",
    },
    rootContainer: {
      padding: "8px 8px",
      width: "max-content",
    },
  });

interface Props extends WithStyles<typeof styles> {
  columns: any;
  data: any;
  retrieveIndicator: any;
}

class EquipmentStatusTableComponent extends React.Component<Props> {
  render() {
    const { columns, data, retrieveIndicator, classes } = this.props;
    return (
      <div style={{ display: "flex", flexDirection: "row" }}>
        <div style={{ width: "100%" }}>
          <TableContainer
            component={Paper}
            classes={{
              root: classes.rootContainer,
            }}
          >
            <Table
              className={classes.table}
              size="small"
              aria-label="a dense table"
            >
              <TableHead>
                <TableRow>
                  <StyledTableCell>Equipments</StyledTableCell>
                  <StyledTableCell align="center">Shifts</StyledTableCell>
                  {columns.map((dateItem: any) => {
                    return (
                      <StyledTableCell key={dateItem.toString()} align="center">
                        {getMomentDate(dateItem, EQUIPMENT_STATUS_DATE_FORMAT)}
                      </StyledTableCell>
                    );
                  })}
                </TableRow>
              </TableHead>
              <TableBody>
                {data.map((machineItem: any) => (
                  <TableRow key={machineItem.machine.toString()}>
                    <StyledTableCell component="th" scope="row">
                      {machineItem.machine}
                    </StyledTableCell>
                    <StyledTableCell>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <div style={{ margin: 5 }}>{"Morning Shift"}</div>
                        <Divider />
                        <div style={{ margin: 5 }}>{"Afternoon Shift"}</div>
                        <Divider />
                        <div style={{ margin: 5 }}>{"Night Shift"}</div>
                      </div>
                    </StyledTableCell>
                    {columns.map((dateItem: any) => {
                      return (
                        <StyledTableCell
                          key={dateItem.toString()}
                          align="center"
                        >
                          <div>
                            {[
                              "Morning Shift",
                              "Afternoon Shift",
                              "Night Shift",
                            ].map((shiftItem: any) => {
                              let indicator = retrieveIndicator(
                                shiftItem,
                                getMomentDate(
                                  dateItem,
                                  EQUIPMENT_STATUS_DATE_FORMAT
                                ),
                                machineItem.machineStatusData
                              );
                              if (indicator) {
                                return (
                                  <div
                                    key={shiftItem.toString()}
                                    style={{
                                      display: "flex",
                                      width: "100%",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      border: "0.1px solid grey",
                                    }}
                                  >
                                    <Avatar
                                      style={{
                                        backgroundColor: indicator,
                                        width: 15,
                                        height: 15,
                                        margin: 5,
                                      }}
                                    >
                                      {""}
                                    </Avatar>
                                  </div>
                                );
                              } else {
                                return (
                                  <div
                                    key={shiftItem.toString()}
                                    style={{
                                      display: "flex",
                                      width: "100%",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      border: "0.1px solid grey",
                                    }}
                                  >
                                    <Avatar
                                      style={{
                                        backgroundColor: "grey",
                                        width: 15,
                                        height: 15,
                                        margin: 5,
                                      }}
                                    >
                                      {""}
                                    </Avatar>
                                  </div>
                                );
                              }
                            })}
                          </div>
                        </StyledTableCell>
                      );
                    })}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div>
    );
  }
}
export default withStyles(styles)(EquipmentStatusTableComponent);
